import styles from "components/pages/blog/search/BlogMain.module.scss";
import { TSearchEngine } from "components/pages/translations/TSearchEngine";
import { useBlogPageContext } from "@/helpers/contexts/BlogPageContext";
import { ArticlesList } from "@/components/pages/blog/search/ArticlesList";

export const TranslationsMain = () => {
  const data = useBlogPageContext();
  if (!data) return null;
  const { articles, categories, pagination, notFound, search, clientPagination } = data;

  return (
    <div className={styles.wrapper}>
      <TSearchEngine
        filteredArticles={articles}
        isSearch={!notFound && !!search}
        pagination={clientPagination}
        taxonomies={categories}
        isLoading={false}
      >
        <ArticlesList
          urlPrefix="/translations"
          pagination={pagination}
          list={articles}
          includeTaxonomyInURL={false}
          heading="Recently added"
        />
      </TSearchEngine>
    </div>
  );
};
